import React, { Component } from "react";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import { EjariProperty } from "@eres/ejari-api/Entity";
import Strings from "@my-dld/assets/strings";
import { I8N, LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { UNIT } from "./SearchProperty";

export interface PropertyResultProps {
	propertyType: number;
	properties: EjariProperty[];
	onDetails: ( item: EjariProperty ) => void;
}

class PropertyResultListView extends Component<PropertyResultProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { propertyType, properties } = this.props;
		return <ListDataView
			items={ properties }
			renderListHeader={ () => <RenderHeader propertyType={ propertyType }/> }
			renderListItem={ ( item: EjariProperty ) => {
				return <RenderListItem
					key={ `prop_res_${ item.PropertyId }` }
					propertyType={ propertyType }
					item={ item }/>;
			} }/>;
	}

	private configDataTable() {
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			const onDetails = this.props.onDetails;
			window.$( "#ListView" ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onDetails( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	}
}

function RenderHeader( props: { propertyType: number } ) {
	const { propertyType } = props;
	const isUnit = propertyType === UNIT.Id;
	return <tr>
		{ isUnit && <th>{ Strings.Unit_Number_Label }</th> }
		<th>{ Strings.area }</th>
		<th>{ isUnit ? Strings.building_name : Strings.villa_name }</th>
		<th>{ Strings.property_status.replace( "<br/>", "" ) }</th>
		<th>{ " " }</th>
	</tr>;
}

function RenderListItem( props: { propertyType: number, item: EjariProperty } ) {
	const { propertyType, item } = props;
	const unitNo = !isEmptyStringOrNull( item.UnitNo ) ? item.UnitNo : "";
	const isUnit = propertyType === UNIT.Id;
	return <tr>
		{ propertyType === UNIT.Id && <td data-label={ Strings.Unit_Number_Label }>{ unitNo }</td> }
		<td data-label={ Strings.area }>{ I8N.isRTL() ? item.AreaAr : item.AreaEn }</td>
		<td data-label={ isUnit ? Strings.building_name : Strings.villa_name }>{ I8N.isRTL() ? item.BuildingNameAr : item.BuildingNameEn }</td>
		<td data-label={ Strings.property_status.replace( "<br/>", "" ) }>{ item.IsRented ? Strings.rented : Strings.vacant }</td>
		<td>
			<a href="#" data-item={ JSON.stringify( item ) }>
				<i className="far fa-arrow-alt-circle-right"/>
			</a>
		</td>
	</tr>;
}

export default PropertyResultListView;
